import React, {Component} from 'react'
import {AntExample} from '../components/Ant.example.js'
class FirstFlyer extends React.Component{
    render(){
        return (
            <div className={'page-list vh-100 bg-primary row justify-content-center'}>
                <div className="col-8 row align-content-center">
                    <div className={'fs-1 fw-bold pb-5 mb-5 text-white '}>Hello, maybe you are looking my repository</div>
                </div>
                <div className="col-2 row align-content-center">
                    <a href="https://github.com/bigclown?tab=repositories" className={'fw-bold text-white text-decoration-none fs-1'}>Here</a>
                </div>

            </div>
        )
    }
}

class SecondFlyer extends React.Component{
    render(){
        return (
            <div className={'page-list vh-100 bg-blue row justify-content-end'}>
                <div className="col-5 row align-content-center">
                    <div className={'fs-1 fw-bold pb-5 mb-5 text-white text-wrap'}>Maybe something else like...</div>
                </div>
                <div className="col-7 row align-content-center bg-black">
                    <div className="col-12 row min-vh-5">
                        <div className="row col m-3 text-white fs-1 ">
                            Input Forms
                        </div>
                    </div>
                    <div className="col-12 row m-4 min-vh-75 bg-white">
                        <div className="col m-3 row">
                            <AntExample/>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}


const flyer = [FirstFlyer, SecondFlyer]
const pages = (page)=>{
    const Comp = flyer[page]
    return (<Comp style={{transition: 'width 2s'}}/>)
}
class PageSwapper extends Component{
    constructor(props) {
        super(props);
        this.state={
            currentPage: 0,
        }
    }
// 7-3
    handleNavigation = (e) => {this.setState((prevState)=> {
        return({
            currentPage:
                ( e > 0  ?  ++prevState.currentPage : --prevState.currentPage)
        })
    })};
    render(){
        return (
            <div>
                <div id="carouselId" className={'carousel slide'}>
                    <div className="row bg-dark" role="listbox">
                        {this.state.currentPage !== 0 ? <div className="col-12 row text-white fs-1"  onClick={()=>this.handleNavigation(-1)}>
                            <i className="bi bi-arrow-up"/>
                        </div> : <div/>}
                        {pages(this.state.currentPage)}
                        {this.state.currentPage < flyer.length-1 ? <div className="col-12 row ">
                            <i className="bi bi-arrow-down text-white fs-1"  onClick={()=>this.handleNavigation(1)}/>
                        </div> : <div/>}
                    </div>
                </div>



            </div>
        )
    }
}



class App extends Component {
    render() {
        return (
            <div className={'min-vh-100 container-fluid'}>
                <PageSwapper/>
            </div>
        )
    }


}

export default App
